import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";

import { MONTHS } from "./utils/constants";

import styleSchema from "./DateSelector.styles";

const monthModifierClassNames = (month, temporaryDate, navigationDate, noYear) => {
  if (noYear) {
    return navigationDate.format("MMM") === month
      ? `${styleSchema.monthSelected}`
      : `${styleSchema.monthDefault}`;
  }

  const monthIndex = MONTHS.indexOf(month);
  if (navigationDate.clone().month(monthIndex).isSame(temporaryDate, "month")) {
    return `${styleSchema.monthSelected}`;
  }

  return `${styleSchema.monthDefault}`;
};

const arialLabelMonth = (month, navigationDate) =>
  `Go to ${month} ${navigationDate.clone().format("YYYY")} to select a day`;

const isDisabled = ({ month, navigationDate, minDate, maxDate }) => {
  const monthIndex = MONTHS.indexOf(month);
  const isBeforeMinDate =
    minDate && navigationDate.clone().set("month", monthIndex).endOf("month").isSameOrBefore(dayjs(minDate));
  const isAfterMaxDate =
    maxDate && navigationDate.clone().set("month", monthIndex).startOf("month").isSameOrAfter(dayjs(maxDate));
  return isBeforeMinDate || isAfterMaxDate;
};

const MonthSelector = ({ temporaryDate, navigationDate, handleMonthClick, minDate, maxDate, noYear }) => {
  const onMonthClick = (month) => {
    handleMonthClick(navigationDate.clone().month(MONTHS.indexOf(month)));
  };

  return (
    <div className="tw-flex tw-flex-col tw-flex-wrap tw-flex-auto tw-justify-center">
      <div className="tw-grid tw-grid-cols-4 tw-justify-items-center">
        {MONTHS.map((month) => {
          const disabled = isDisabled({ month, navigationDate, minDate, maxDate });
          return (
            <button
              key={month}
              tabIndex={0}
              type="button"
              onClick={() => onMonthClick(month)}
              className={`
                ${monthModifierClassNames(month, temporaryDate, navigationDate, noYear)}
                ${disabled ? "!tw-text-semantic-red-10" : ""}
              `}
              aria-label={arialLabelMonth(month, navigationDate)}
              data-test-date={month}
              disabled={disabled}
            >
              {month}
            </button>
          );
        })}
      </div>
    </div>
  );
};

MonthSelector.propTypes = {
  temporaryDate: PropTypes.shape(),
  navigationDate: PropTypes.shape(),
  handleMonthClick: PropTypes.func,
  minDate: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  noYear: PropTypes.bool,
};

MonthSelector.defaultProps = {
  temporaryDate: dayjs(),
  navigationDate: dayjs(),
  handleMonthClick: () => {},
  minDate: null,
  maxDate: null,
  noYear: false,
};

export default MonthSelector;
